export default "__VITE_ASSET__Cw6fy3vV__"